import module from 'fanconsultores/module.js'
import template from './template.html'

class AppLogoutComponent {
  constructor ($urlRouter) {
    this.$urlRouter = $urlRouter
  }

  $access () {
    this.$urlRouter.sync()
  }
}

module.component('appLogout', {
  controller: AppLogoutComponent,
  template,
})



// WEBPACK FOOTER //
// ./src/fanconsultores/components/app/logout/component.js